import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { sanitizeSensitiveIdentifierMessage } from './sensitive-message.util';

export function getSafeErrorMessage(
  message: unknown,
  translate: TranslateService,
  nonUsbsFallbackKey: string
): string {
  if (environment.isUsbsEnvironment) {
    return translate.instant('errors.usbs.generic');
  }

  const fallback = translate.instant(nonUsbsFallbackKey);
  return sanitizeSensitiveIdentifierMessage(message, fallback);
}
